import React,{useState,useContext} from 'react'
import { StudentDetailsContext } from '../store/student-details'
const ViewFeeDetails = () => {
    const StudentContext = useContext(StudentDetailsContext);
    const[AdmissionNumber,setAdmissionNumber] = useState("");
   function handleForm(e){
    e.preventDefault();
    StudentContext.loadFeeDetails(AdmissionNumber);
   }
  return (
    <div className='container'>
        <div className='row'>
            <div className="card col-lg-10">
                <form>
                    <div className="col-lg-10 my-4">
                        <input type="number" className='form-control' placeholder='Enter Student Admission Number'
                            onChange={(e)=>setAdmissionNumber(e.target.value)}
                        />
                    </div>
                    <button className='btn btn-sm btn-primary'
                    type="submit"
                    onClick={(e)=>handleForm(e)}>Search</button>
                </form>
            </div>

            <div className="card my-4 col-lg-6">
                {StudentContext && (
                    StudentContext.feeDetails && (
                        StudentContext.feeDetails.map((student)=>(<div>
                            <p className='text text-danger'>AdmissionNumber - {student.Student.AdmissionNumber}</p>
                            {student.Student.Payments && student.Student.Payments.map((payment)=>(<>
                                <p className="text text-success">Amount - {payment.money}</p>
                                <p className='text text-primary'>Date - {payment.date}</p>
                                <hr/>   
                            </>))}
                        </div>))
                    )
                )} 
            </div>
        </div>
    </div>
  )
}

export default ViewFeeDetails